// ── "What changed" line on the A/P Aging Trend card ─────────────────────────
// The rules are in src/shared/apInsights.js (mirroring the Insights checks
// "AP aging shift" and "AP aging drift"); this only fetches their thresholds
// and draws what fires. Renders nothing when nothing fires — a line that
// restates the chart teaches people to skip it.
import { useState, useEffect, useMemo } from "react";
import { useApp } from "../../shared/appContext";
import { AP_DEFAULTS, apThresholds, apAgingInsights } from "../../shared/apInsights";

const TONE = {
  High:   { fg: "#993C1D", bg: "#FAECE7", bar: "#993C1D" },
  Medium: { fg: "#7A5200", bg: "#FDF0D5", bar: "#E9A32A" },
};

// The Insights thresholds, read once per page. Anyone who cannot read them
// (no Portfolio access, table not deployed) gets the seeded defaults.
export const useApThresholds = () => {
  const { api } = useApp();
  const [th, setTh] = useState(AP_DEFAULTS);
  useEffect(() => {
    let live = true;
    api.get("getInsightThresholds")
      .then(rows => { if (live) setTh(apThresholds(rows)); })
      .catch(() => {});
    return () => { live = false; };
    // eslint-disable-next-line
  }, []);
  return th;
};

export const ApAgingFindings = ({ hist, asOf, th }) => {
  const { findings } = useMemo(() => apAgingInsights(hist, asOf, th), [hist, asOf, th]);
  if (!findings.length) return null;
  return (
    <div style={{ display: "grid", gap: 8, gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))", padding: "0 12px 8px" }}>
      {findings.map(f => {
        const t = TONE[f.severity] || TONE.Medium;
        return (
          <div key={f.key} style={{ padding: "8px 10px", borderRadius: 6, fontSize: 12, lineHeight: 1.5,
                                    background: t.bg, borderLeft: "3px solid " + t.bar }}>
            <div style={{ fontWeight: 600, color: t.fg }}>{f.severity} · {f.title}</div>
            <div style={{ color: "var(--color-text-secondary)", marginTop: 2 }}>{f.detail}</div>
          </div>
        );
      })}
    </div>
  );
};
